import { describeError } from '@/lib/auth';
import { useTranslation } from '@/lib/i18n';
import { Alert } from './alert';
import { FormSkeleton } from './loaders';

export function RecordState({ error, missing, label }: { error?: unknown; missing?: boolean; label?: string }) {
  const common = useTranslation('common');
  if (error) return <Alert variant="destructive">{describeError(error)}</Alert>;
  if (missing) return <Alert variant="destructive">{common.t('state.error')}</Alert>;
  return <FormSkeleton aria-label={label ?? common.t('state.loading')} />;
}
